package com.rosario.juridico.ui.screens

import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import com.rosario.juridico.domain.model.CartaDocumentoItem
import com.rosario.juridico.domain.model.MediacionGasto
import com.rosario.juridico.platform.FirebaseProxy
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

class MediacionGastoViewModel {
    var mediacionGasto = mutableStateOf(MediacionGasto())
    val cartasDocumento = mutableStateListOf<CartaDocumentoItem>()
    private val scope = CoroutineScope(Dispatchers.Main + SupervisorJob())

    init {
        loadUserData()
    }

    fun loadUserData() {
        val uid = FirebaseProxy.getCurrentUserId() ?: return
        scope.launch {
            try {
                val doc = Firebase.firestore.collection("usuarios_mediacion").document(uid).get()
                if (doc.exists) {
                    val dataMediador = doc.get<Map<String, String>?>("datos_mediador")
                    val dataOficina = doc.get<Map<String, String>?>("datos_oficina")
                    val dataPago = doc.get<Map<String, String>?>("datos_pago")

                    mediacionGasto.value = mediacionGasto.value.copy(
                        mediadorNombre = dataMediador?.get("nombre_completo") ?: mediacionGasto.value.mediadorNombre,
                        mediadorMatricula = dataMediador?.get("matricula") ?: mediacionGasto.value.mediadorMatricula,
                        mediadorRegistro = dataMediador?.get("registro") ?: mediacionGasto.value.mediadorRegistro,
                        mediadorJurisdiccion = dataMediador?.get("jurisdiccion") ?: mediacionGasto.value.mediadorJurisdiccion,

                        oficinaCalle = dataOficina?.get("calle_numero") ?: mediacionGasto.value.oficinaCalle,
                        oficinaCiudad = dataOficina?.get("localidad") ?: mediacionGasto.value.oficinaCiudad,
                        oficinaTelefono = dataOficina?.get("telefono") ?: mediacionGasto.value.oficinaTelefono,
                        oficinaEmail = dataOficina?.get("email_contacto") ?: mediacionGasto.value.oficinaEmail,

                        pagoBanco = dataPago?.get("banco") ?: mediacionGasto.value.pagoBanco,
                        pagoCbu = dataPago?.get("cbu") ?: mediacionGasto.value.pagoCbu,
                        pagoAlias = dataPago?.get("alias") ?: mediacionGasto.value.pagoAlias,
                        pagoCuitCuil = dataPago?.get("cuit_cuil") ?: mediacionGasto.value.pagoCuitCuil
                    )
                }
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    fun saveMediadorData() {
        val uid = FirebaseProxy.getCurrentUserId() ?: return
        val gasto = mediacionGasto.value
        val data = mapOf(
            "datos_mediador" to mapOf(
                "nombre_completo" to gasto.mediadorNombre,
                "matricula" to gasto.mediadorMatricula,
                "registro" to gasto.mediadorRegistro,
                "jurisdiccion" to gasto.mediadorJurisdiccion
            )
        )
        scope.launch {
            try {
                Firebase.firestore.collection("usuarios_mediacion").document(uid).set(data, merge = true)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    fun saveOficinaData() {
        val uid = FirebaseProxy.getCurrentUserId() ?: return
        val gasto = mediacionGasto.value
        val data = mapOf(
            "datos_oficina" to mapOf(
                "calle_numero" to gasto.oficinaCalle,
                "localidad" to gasto.oficinaCiudad,
                "telefono" to gasto.oficinaTelefono,
                "email_contacto" to gasto.oficinaEmail
            )
        )
        scope.launch {
            try {
                Firebase.firestore.collection("usuarios_mediacion").document(uid).set(data, merge = true)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    fun savePagoData() {
        val uid = FirebaseProxy.getCurrentUserId() ?: return
        val gasto = mediacionGasto.value
        val data = mapOf(
            "datos_pago" to mapOf(
                "banco" to gasto.pagoBanco,
                "cbu" to gasto.pagoCbu,
                "alias" to gasto.pagoAlias,
                "cuit_cuil" to gasto.pagoCuitCuil
            )
        )
        scope.launch {
            try {
                Firebase.firestore.collection("usuarios_mediacion").document(uid).set(data, merge = true)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    fun setInitialData(
        honorariosJus: Double,
        honorariosPesos: Double,
        aportesJus: Double,
        aportesPesos: Double,
        gastosAdminJus: Double,
        gastosAdminPesos: Double,
        valorJus: Double,
        tipoMediacion: String
    ) {
        val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
        val fecha = "${now.dayOfMonth}/${now.monthNumber}/${now.year}"
        
        mediacionGasto.value = MediacionGasto(
            fechaFormulario = fecha,
            honorariosJus = honorariosJus,
            honorariosPesos = honorariosPesos,
            aportesJus = aportesJus,
            aportesPesos = aportesPesos,
            gastosAdministrativosJus = gastosAdminJus,
            gastosAdministrativosPesos = gastosAdminPesos,
            valorJus = valorJus,
            tipoMediacion = tipoMediacion
        )
        cartasDocumento.clear()
    }

    fun addCartaDocumento() {
        cartasDocumento.add(CartaDocumentoItem(id = Clock.System.now().toEpochMilliseconds().toString()))
    }

    fun removeCartaDocumento(item: CartaDocumentoItem) {
        cartasDocumento.remove(item)
    }

    fun updateCartaDocumento(id: String, nombre: String, calle: String, ciudad: String, monto: Double) {
        val index = cartasDocumento.indexOfFirst { it.id == id }
        if (index != -1) {
            cartasDocumento[index] = cartasDocumento[index].copy(
                destinatarioNombre = nombre,
                destinatarioCalle = calle,
                destinatarioCiudad = ciudad,
                monto = monto
            )
        }
    }
    
    fun getFinalGasto(): MediacionGasto {
        return mediacionGasto.value.copy(cartasDocumento = cartasDocumento.toList())
    }

    companion object {
        val instance = MediacionGastoViewModel()
    }
}
